const partnerLogos = [
  {
    name: "Green Harbor",
    logo: require("./images/greenHarbor.png"),
    link: "https://www.greenharbor-am.com/",
  },
  {
    name: "Columbia Capital",
    logo: require("./images/columbiaCapital.png"),
    link: "http://www.columbia-capital.com/",
  },
  {
    name: "KPMG",
    logo: require("./images/kpmg.png"),
    link: "https://kpmg.com/kr/ko/home.html",
  },
  {
    name: "Jefferies",
    logo: require("./images/jefferies.png"),
    link: "https://www.jefferies.com/",
  },
  {
    name: "Ventum Finance",
    logo: require("./images/ventum.png"),
    link: "https://ventumfinancial.com/",
  },

  {
    name: "Dumoulin Black",
    logo: require("./images/dumoulin.png"),
    link: "https://www.dumoulinblack.com/",
  },
  {
    name: "DMCL",
    logo: require("./images/dmcl.png"),
    link: "https://www.dmcl.ca/",
  },
  {
    name: "Canaccord Genuity",
    logo: require("./images/canaccord.png"),
    link: "https://www.canaccordgenuity.com/",
  },
];

export default partnerLogos;
